// app/javascript/controllers/ui/input_rating_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["star"];

  connect() {
    this.updateStars();

    // Add hover listeners
    this.starTargets.forEach((star, index) => {
      star.addEventListener("mouseenter", () => this.highlightStars(index + 1));
      star.addEventListener("mouseleave", () => this.updateStars());
    });
  }

  updateStars() {
    // Find the selected radio button
    const selected = this.element.querySelector('input[type="radio"]:checked');
    const selectedValue = selected ? parseInt(selected.value) : 0;

    // Update stars based on selected value
    this.starTargets.forEach((star, index) => {
      const starPosition = index + 1;
      if (starPosition <= selectedValue) {
        star.classList.add("text-yellow-400", "fill-yellow-400");
        star.classList.remove("opacity-30");
      } else {
        star.classList.remove("text-yellow-400", "fill-yellow-400");
        star.classList.add("opacity-30");
      }
    });
  }

  highlightStars(position) {
    // Temporarily highlight stars on hover
    this.starTargets.forEach((star, index) => {
      const starPosition = index + 1;
      if (starPosition <= position) {
        star.classList.add("text-yellow-400", "fill-yellow-400");
        star.classList.remove("opacity-30");
      } else {
        star.classList.remove("text-yellow-400", "fill-yellow-400");
        star.classList.add("opacity-30");
      }
    });
  }

  // Handle star click
  selectStar(event) {
    const position = parseInt(event.currentTarget.dataset.value);
    const radio = this.element.querySelector(`input[value="${position}"]`);
    if (radio) {
      radio.checked = true;
      this.updateStars();

      // Dispatch change event to trigger any form listeners
      const changeEvent = new Event("change", { bubbles: true });
      radio.dispatchEvent(changeEvent);
    }
  }
}
